<div id="downloadDialog" class="flex flex-col justify-center items-center p-6">
  <p-progress-spinner strokeWidth="8" fill="transparent"></p-progress-spinner>
  <div id="message" class="mt-4 text-center text-base">
    {{'DownloadWaitDialog.Loading'|translate}}
  </div>
</div>
